import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
export function useCountWithInterval(initialCount, t0) {
  const $ = _c(6);
  const {
    max,
    paused,
    increase: t1,
    intervalMs
  } = t0;
  const increase = t1 === undefined ? true : t1;
  const [count, setCount] = useState(initialCount);
  let t2;
  let t3;
  if ($[0] !== increase || $[1] !== intervalMs || $[2] !== max || $[3] !== paused) {
    t2 = () => {
      if (paused) {
        return;
      }
      const interval = setInterval(() => {
        setCount(p => increase ? Math.min(p + 1, max || Number.POSITIVE_INFINITY) : Math.max(p - 1, 0));
      }, intervalMs);
      return () => clearInterval(interval);
    };
    t3 = [increase, intervalMs, max, paused];
    $[0] = increase;
    $[1] = intervalMs;
    $[2] = max;
    $[3] = paused;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  return count;
}
export function useTick(enabled, intervalMs) {
  const $ = _c(3);
  const t0 = !enabled;
  let t1;
  if ($[0] !== intervalMs || $[1] !== t0) {
    t1 = {
      paused: t0,
      intervalMs
    };
    $[0] = intervalMs;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useCountWithInterval(0, t1);
}